import { render, staticRenderFns } from "./RejectedByHO.vue?vue&type=template&id=a181592c&scoped=true&lang=pug"
import script from "./RejectedByHO.vue?vue&type=script&lang=ts"
export * from "./RejectedByHO.vue?vue&type=script&lang=ts"
import style0 from "./RejectedByHO.vue?vue&type=style&index=0&id=a181592c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a181592c",
  null
  
)

/* custom blocks */
import block0 from "./RejectedByHO.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Frunner%2Fwork%2Fcompliance-nationbetter-uk%2Fcompliance-nationbetter-uk%2Fsrc%2Fcomponents%2FWidgets%2FHighlights%2FCoS%2BSW%2FHighlight%2FRejectedByHO.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports